class PurchaseOrderFormatService extends BaseService
	@registerService()
	@inject 'EntityAttributeService',
		'PurchaseOrderShippingCostService'
		'BACKEND_PRODUCT_DATA_ENTITY_TYPE'

	productToReport: (product, stockLocationId, priceRegionId) ->
		lineItems = []

		if _.isEmpty product.product_variants
			lineItems.push {
				id: null
				product_id: product.id
				product_variant_id: null
				requested_quantity: 0
				received_quantity: null
				unit_id: product.product_data[0]?.unit_id ? 'pc'
				cost_price: product.product_data[0]?.cost_price ? 0
				stock_values: product.stock_values
				product: product
				product_variant: null
				number_in_package: @getNumberInPackage(product, 'BACKEND_PRODUCT_ATTRIBUTE_TYPE')
			}
		else
			for variant in product.product_variants
				lineItems.push {
					id: null
					product_id: variant.product_id
					product_variant_id: variant.id
					requested_quantity: 0
					received_quantity: null
					unit_id: variant.product_data[0]?.unit_id ? 'pc'
					cost_price: variant.product_data[0]?.cost_price ? 0
					stock_values: variant.stock_values
					product: product
					product_variant: variant
					number_in_package: @getNumberInPackage(variant, 'BACKEND_PRODUCT_VARIANT_ATTRIBUTE_TYPE')
				}

		return @purchaseOrderToReport({line_items: lineItems, price_region_id: priceRegionId}, stockLocationId)

	getNumberInPackage: (item, attributeType) ->
		if !item.attributes?
			return null

		attributeService = @EntityAttributeService.getNewInstance()
		attributeService.setEntity(item, attributeType)

		if attributeService.hasAttribute('number_in_package')
			return parseFloat(attributeService.attributes.number_in_package.value)

	purchaseOrderToReport: (purchaseOrder, stockLocationId) ->
		lineItems = []
		stockLocationId ?= purchaseOrder.stock_location_id

		totalQuantity = _.reduce(
			purchaseOrder.line_items,
			(accumulator, item) -> return accumulator + parseFloat(item.received_quantity ? item.requested_quantity ? 0),
			0,
		)
		totalShippingCost = purchaseOrder.shipping_cost
		unitShippingCost = @PurchaseOrderShippingCostService.calculateUnitShippingCost(totalShippingCost, totalQuantity)

		for lineItem in purchaseOrder.line_items
			lineItem.shipping_cost = unitShippingCost
			lineItems.push @convertLineItemToReport(lineItem, stockLocationId, purchaseOrder.price_region_id)

		return @groupLineItems(lineItems)

	groupLineItems: (lineItems) ->
		return _.chain lineItems
			.groupBy 'product_id'
			.values()
			.value()

	convertLineItemToReport: (lineItem, stockLocationId, priceRegionId) ->
		if @isLineItemConvertedToReport lineItem
			return lineItem

		stockValues = null
		reportLineItem =
			id: lineItem.id
			product_id: lineItem.product_id
			product_name: lineItem.product.name
			product_supplier_id: lineItem.product.supplier_id
			product_supplier_reference_id: lineItem.product.supplier_reference_id
			product_variant_id: lineItem.product_variant_id
			product_variant_name: null
			product_variant_supplier_id: null
			product_variant_supplier_reference_id: null
			quantity: 0
			min_quantity: 0
			cost_price: if parseInt(lineItem.cost_price) > 0 then parseInt(lineItem.cost_price) else null
			actual_cost_price: @getCostPrice(lineItem.product.product_data, priceRegionId)
			shipping_cost: lineItem.shipping_cost
			unit_id: lineItem.unit_id
			requested_quantity: lineItem.requested_quantity
			received_quantity: lineItem.received_quantity
			number_in_package: if lineItem.number_in_package? then parseFloat(lineItem.number_in_package) else null

		if lineItem.product_variant_id? and not _.isEmpty(lineItem.product_variant)
			reportLineItem = angular.extend(
				reportLineItem,
				{
					actual_cost_price: @getCostPrice(lineItem.product_variant.product_data, priceRegionId)
					product_variant_name: lineItem.product_variant.product_variant_name
					product_variant_supplier_id: lineItem.product_variant.supplier_id
					product_variant_supplier_reference_id: lineItem.product_variant.supplier_reference_id
				}
			)

			if not _.isEmpty(lineItem.product_variant.stock_values)
				stockValues = lineItem.product_variant.stock_values
		else if not _.isEmpty(lineItem.product.stock_values)
			stockValues = lineItem.product.stock_values

		if stockLocationId? and stockValues?
			stockLocationValues = _.find stockValues, {stock_location_id: stockLocationId}

			if stockLocationValues?
				reportLineItem.quantity = stockLocationValues.quantity
				reportLineItem.min_quantity = stockLocationValues.min_quantity
		else if not stockLocationId?
			console.error 'Can not set min_quantity and quantity because stockLocationId is not set', lineItem, stockLocationId

		return reportLineItem

	convertQuantityTypes: (products) ->
		precision = if products[0].unit_id == 'pc' then 0 else 3

		for product in products
			product.quantity = parseFloat(product.quantity or 0).toFixed(precision)
			product.min_quantity = parseFloat(product.min_quantity or 0).toFixed(precision)
			product.requested_quantity = parseFloat(product.requested_quantity or 0)
			product.received_quantity = if product.received_quantity? then parseFloat(product.received_quantity) else null

	isLineItemConvertedToReport: (lineItemToCheck) ->
		return lineItemToCheck.hasOwnProperty('virtual') &&
			lineItemToCheck.hasOwnProperty('average_per_day') &&
			!lineItemToCheck.hasOwnProperty('product')

	getCostPrice: (productDataList, priceRegionId) ->
		return null if !priceRegionId?

		productData = _.find(
			productDataList
			{
				price_region_id: priceRegionId
				entity_type: @BACKEND_PRODUCT_DATA_ENTITY_TYPE.PRODUCT_DATA
			}
		)

		if parseInt(productData?.cost_price) > 0
			return parseInt(productData.cost_price)

		return null
